/*********************************************************************************
* BTI425 – Assignment 2
* I declare that this assignment is my own work in accordance with Seneca Academic Policy.
* No part of this assignment has been copied manually or electronically from any other source
* (including web sites) or distributed to other students.
*
* Name: Thi Hong Minh Le (Melanie) - Student ID: 103087201  Date: February 26th, 2022
* Heroku Link: https://react-weatherapp-melanie.herokuapp.com/
*
********************************************************************************/
import React from 'react';
import ReactDOM from 'react-dom';
import Routing from './Routing'

ReactDOM.render(
  <React.StrictMode>
    <Routing />
  </React.StrictMode>,
  document.getElementById('root')
);


